'use client';

import styles from './PricingSectionV2.module.css';

export interface BundleOfferStepProps {
  planTitle: string;
  planPrice: number;
  planMeta: string;
  bundlePrice?: number;
  bundleValue?: number;
  onChooseBundle: (addBundle: boolean) => void;
}

export default function BundleOfferStep({
  planTitle,
  planPrice,
  planMeta,
  bundlePrice = 40,
  bundleValue = 300,
  onChooseBundle,
}: BundleOfferStepProps) {
  return (
    <div className={styles.bundleOfferLayout}>
      <section className={styles.bundleChosenPlan} aria-labelledby="bundle-chosen-plan">
        <h2 id="bundle-chosen-plan" className={styles.detailPlanTitle}>
          {planTitle}
        </h2>
        <p className={styles.detailPlanPrice}>${planPrice}/mo</p>
        <p className={styles.detailPlanMeta}>{planMeta}</p>
      </section>

      <section className={styles.bundleUpsell} aria-labelledby="bundle-upsell-title">
        <div className={styles.bundleUpsellHeader}>
          <p className={styles.bundleUpsellEyebrow}>Special offer for live students only</p>
          <h3 id="bundle-upsell-title" className={styles.bundleUpsellTitle}>
            Unlimited VOD bundle
          </h3>
        </div>
        <p className={styles.bundleUpsellCopy}>
          Our Streaming VOD offers access to a curated collection of all past classes.
        </p>
        <p className={styles.bundleUpsellCopy}>
          Unlimited access is recommended for those looking to deepen their progress and get extra
          practice at home between live classes. Stream VOD on your schedule, at your own pace.
        </p>
        <div className={styles.bundleUpsellPriceRow}>
          <span className={styles.bundleUpsellPrice}>
            ${bundlePrice}/mo
            <span className={styles.bundleUpsellPriceValue}> · ${bundleValue} value</span>
          </span>
          <p className={styles.footnote}>Add on with live membership.</p>
        </div>
      </section>

      <section className={styles.bundleActions} aria-label="Bundle options">
        <button type="button" className={styles.btnPrimary} onClick={() => onChooseBundle(true)}>
          Add unlimited VOD
        </button>
        <button type="button" className={styles.btnBlack} onClick={() => onChooseBundle(false)}>
          Continue with live only
        </button>
      </section>
    </div>
  );
}
